<template>
  <navigation-bar></navigation-bar>

  <div class="filter-panel">
    <div class="filter-left">
      <label>Időszak:</label>
      <input type="date" v-model="selectedFromDate">
      <input type="date" :value="selectedToDateComputed" disabled>

      <button @click="setWeekRange('prev')">Előző hét</button>
      <button @click="setWeekRange('current')">Akt. hét</button>
      <button @click="setWeekRange('next')">Következő hét</button>

      <label>Diszpécser:</label>
      <select v-model="selectedDisponent">
        <option value="all">Összes</option>
        <option v-for="disp in disponents" :key="disp.name" :value="disp.name">
          {{ disp.name }}
        </option>
      </select>

      <button @click="fetchTasks">Adatok lehívása</button>
    </div>

    <div class="view-toggle">
      <button @click="showGantt = !showGantt">
        {{ showGantt ? 'Táblázat nézet' : 'Idővonal nézet' }}
      </button>
    </div>

    <div class="export-button-container">
      <button @click="exportCurrentViewToPdf">PDF</button>
    </div>



  <div class="export-button-container">
     <button @click="openFeladatList">Feladat lista</button>
  </div>


  <button @click="openDiszpecserList">Súly/dátum</button>

      <div class="zoom-controls">
        <button @click="dayCountOut">−</button>
        <span>{{ visibleDayCount }} nap</span>
        <button @click="dayCountIn">+</button>
      </div>
    </div>

  <div id="gantt-export-content" class="gantt-container" v-if="showGantt">
    <div class="gantt-left">
      <div class="time-header-placeholder"></div>
      <table class="tasks-table">
        <thead>
          <tr>
            <th>Diszp.</th>
            <th>Rendsz</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="group in groupedTasks" :key="group.rendszam">
            <td>{{ group.akt_diszpecser }}</td>
            <td>{{ group.rendszam }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="gantt-right" ref="ganttContainer">
      <div class="gantt-header">
        <div class="gantt-header-scale" :style="{ width: ganttWidthZoomed + 'px' }">
          <div
            v-for="(day, index) in daysArray"
            :key="'day-' + index"
            class="gantt-header-day"
            :style="{ width: pxPerDay + 'px' }"
          >
            {{ day.format('MM.DD.') }} {{ day.format('dddd').toLowerCase() }}
          </div>
        </div>

        <div class="gantt-time-scale" :style="{ width: ganttWidthZoomed + 'px' }">
          <div
            v-for="(day, index) in daysArray"
            :key="'hours-' + index"
            class="gantt-time-label-group"
            :style="{ width: pxPerDay + 'px' }"
          >
            <div
              v-for="hour in [7, 12, 17]"
              :key="'hour-label-' + index + '-' + hour"
              class="gantt-time-label"
              :style="{ left: ((hour - startHour) * pxPerHour) + 'px' }"
            >
              {{ hour }}:00
            </div>
          </div>
        </div>
      </div>

      <div class="gantt-body" :style="{ width: ganttWidthZoomed + 'px' }">
        <div
          v-for="(day, index) in daysArray"
          :key="'line-' + index"
          class="gantt-day-line"
          :style="{ left: `${index * (ganttWidthZoomed / daysArray.length)}px` }"
        >
        </div>

        <div
          v-for="(line, index) in hourLines"
          :key="'hour-line-' + index"
          class="gantt-hour-line"
          :style="{ left: line.left, ...line.style }"
        ></div>

      <div v-for="group in groupedTasks" :key="group.rendszam" class="gantt-row">
          <div
            v-for="task in filteredTasks(group.tasks)"
            :key="task.az"
            class="gantt-bar-wrapper"
            style="position: relative;"
            >
            <div
              class="gantt-bar"
              :style="barStyle(task)"
              @contextmenu.prevent="openContextMenu($event, task)"
              @mousedown="dragTask(task, $event)"
            :title="`
                Megrendelő: ${task.megrendelo}
                Útvonal: ${task.route}
                Rakodási hely: ${task.fhely}
                Lerakási hely: ${task.lhely}
                Távolság: ${task.m_km} km
                Terv.ind: ${task.planned_start.format('YYYY. MM. DD. HH:mm')}
                Terv.érk: ${task.planned_end.format('YYYY. MM. DD. HH:mm')}
              `"
              style="position: relative;"
            >
              <div class="resize-handle left" @mousedown.stop="resizeTask(task, 'start', $event)"></div>
              <div class="resize-handle right" @mousedown.stop="resizeTask(task, 'end', $event)"></div>
              <!-- Beide label direkt nacheinander im Balken -->
            <!-- Immer einen Label-Span im Balken, aber abhängig von showTextInBar sichtbar -->
              <span
                v-if="showTextInBar(task)"
                class="bar-label"
              >
                {{ getFullRelation(task.felrako, task.lerako) }}
              </span>

              
            </div>
            <!-- Wenn nicht genug Platz: Text außerhalb, aber IMMER im gleichen Wrapper, daher korrekt neben dem Balken! -->
             <span
                v-if="!showTextInBar(task)"
                class="bar-label-outside"
                :title="getFullRelation(task.felrako, task.lerako)"
                :style="barLabelOutsideStyle(task)"
               >
                {{ getFullRelation(task.felrako, task.lerako) }}
              </span>


        </div>

      </div>


        
      </div>
    </div>
  </div>

  <div id="table-export-content" class="routes-table-wrapper" v-if="!showGantt">
    <table class="routes-table">
      <thead>
        <tr>
          <th>Diszp.</th>
          <th>Rendsz</th>
          <th v-for="(day, index) in daysArray" :key="'col-' + index">
            {{ day.format('MM.DD. dddd') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
            v-for="row in dailyRouteMatrix"
            :key="row.rendszam"
          >
          <td>{{ row.akt_diszpecser }}</td>
          <td>{{ row.rendszam }}</td>
          <td
              v-for="(route, i) in row.routes"
              :key="i"
              @contextmenu.prevent="openTableContextMenu($event, row, i)"
            >
              <pre class="cell-multiline">{{ route }}</pre>
            </td>
        </tr>
      </tbody>
    </table>
  </div>

    <ul
      v-if="tableContextMenuVisible"
      class="context-menu"
      :style="{ top: `${tableContextMenuPosition.y}px`, left: `${tableContextMenuPosition.x}px` }"
      @click.self="closeTableContextMenu"
    >
      <li @click="handleTableMenu('newDrive')">Új viszonylat hozzáadása</li>
    </ul>

    <ul
      v-if="contextMenuVisible"
      class="context-menu"
      :style="{ top: `${contextMenuPosition.y}px`, left: `${contextMenuPosition.x}px` }"
      @click.stop   
    >
      <li @click="handleMenu('setTime', contextMenuTask)">Tervezett kezd-bef. beállítása</li>
      <li @click="handleMenu('plan', contextMenuTask)">Betervezve</li>
      <li @click="openFieldDialog('felrakasDatum', contextMenuTask)">Felrakás dátum</li>
      <li @click="openFieldDialog('lerakasDatum', contextMenuTask)">Lerakás dátum</li>
      <li @click="openFieldDialog('felrakoSuly', contextMenuTask)">Felrakó súly</li>
      <li @click="openFieldDialog('lerakoSuly', contextMenuTask)">Lerakó súly</li>
        <hr>
     <li @click="deleteFuvar(contextMenuTask.drive_az, contextMenuTask.oldal)">Fuvar törlése</li>

    </ul>




  <div
    v-if="timeEditorVisible"
    class="time-editor"
    :style="{ top: `${contextMenuPosition.y + 40}px`, left: `${contextMenuPosition.x}px` }"
  >
    <label>Kezdés:</label>
    <input type="datetime-local" v-model="editStart" />

    <label>Befejezés:</label>
    <input type="datetime-local" v-model="editEnd" />

    <div class="editor-actions">
      <button @click="saveTimeEdit">Mentés</button>
      <button @click="cancelTimeEdit">Mégse</button>
    </div>
  </div>

  <div v-if="showDriveSelector" class="modal-overlay">
    <div class="modal">
      <h3>Elérhető viszonylatok – {{ selectedDate.format('YYYY. MM. DD.') }}</h3>
      <ul class="drive-list">
       <li v-for="(drive) in freeDrives" :key="drive.napifo_az" @click="selectDrive(drive)">
          <strong>{{ drive.viszonylat }}</strong> |
          {{ drive.cikk }} |
          {{ drive.megrendelo }} |
          <em>{{ drive.fsz }}</em>
        </li>
      </ul>
      <div class="modal-actions">
        <button @click="closeDriveSelector">Mégse</button>
      </div>
    </div>
  </div>

<div v-show="showFieldDialog" class="modal-overlay">
  <div class="modal">
    <h3>{{ dialogTitle }}</h3>
    <input
      v-model="fieldValue"
      :type="dialogInputType"
      class="form-control"
      style="margin-bottom:16px"
    />
    <div class="editor-actions">
      <button @click="saveFieldValue">Mentés</button>
      <button @click="showFieldDialog = false">Mégse</button>
    </div>
  </div>
</div>



</template>


<script>
import dayjs from 'dayjs';
import axiosInstance from "@/axiosInstance";
import { mapGetters } from 'vuex';
import html2pdf from 'html2pdf.js'; // <-- NEU: html2pdf.js importieren

import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

import 'dayjs/locale/hu';
dayjs.locale('hu');


export default {
  name: 'GanttChart',
  data() {
    return {
    selectedFromDate: dayjs().startOf('isoWeek').format('YYYY-MM-DD'),
    selectedToDate: dayjs().endOf('isoWeek').format('YYYY-MM-DD'),
    selectedDisponent: 'all',
    disponents: [],
    tasks: [],
    chartStart: dayjs().startOf('isoWeek'),  // Setzt Montag als Start
    chartEnd: dayjs().endOf('isoWeek'),       // Setzt Sonntag als Ende
    ganttWidth: window.innerWidth - 320, // Dynamische Breite
    zoomLevel: 1,  // 1 = 100%, 2 = 200%, 0.5 = 50% usw.
    visibleDayCount: 7, // Standard: 7 Tage sichtbar
    startHour: 6,
    endHour: 20,

       contextMenuVisible: false,
    contextMenuPosition: { x: 0, y: 0 },
    selectedTask: null,
    contextMenuListener: null,

      timeEditorVisible: false,
    editStart: null,
    editEnd: null,
  
    kivalasztott_task: null,
    kivalasztottTaskObj: null,

    showGantt: true,
    
    tableContextMenuVisible: false,
    tableContextMenuPosition: { x: 0, y: 0 },
    selectedTableRow: null,
    selectedDate: null,

    showDriveSelector: false,
    freeDrives: [],
    selectedDrive: null,

    selectedRendszam: null,
    selectedDatumString: null, // als String im Format 'YYYY-MM-DD'

    showFieldDialog: false,
    dialogTitle: '',
    fieldValue: '',
    fieldType: '',
    dialogInputType: 'text',


  };
},

computed: {
  ...mapGetters(["getUserData"]),
  ...mapGetters(["getUserData", "getUserType"]),

  ceg_az() {
              return this.getUserData ? this.getUserData.ceg_az : null;
  },
    
  chartEndComputed() {
    return dayjs(this.chartStart).add(this.visibleDayCount - 1, 'day').endOf('day');
  },

  selectedToDateComputed() {
    return dayjs(this.selectedFromDate).add(this.visibleDayCount - 1, 'day').format('YYYY-MM-DD');
  },


  ganttWidthZoomed() {
    return this.ganttWidth * this.zoomLevel;
  },


  pxPerHour() {
    const totalVisibleHours = (this.endHour - this.startHour) * this.visibleDayCount;
    return this.ganttWidthZoomed / totalVisibleHours;
  },
  pxPerDay() {
    return this.pxPerHour * 24;
  },

  hourLines() {
    const lines = [];
    const pxPerHour = this.pxPerHour;

    for (let d = 0; d < this.visibleDayCount; d++) {
      for (let h = this.startHour; h < this.endHour; h++) {
        const index = d * (this.endHour - this.startHour) + (h - this.startHour);
        const isHighlight = [7, 12, 17].includes(h);

        lines.push({
          hour: h,
          left: `${index * pxPerHour}px`,
          style: {
            width: '1px',
            backgroundColor: h === this.startHour ? 'red' : isHighlight ? '#666' : 'rgba(0,0,0,0.08)'
          }
        });
      }
    }

    return lines;
  },

  daysArray() {
      if (!this.chartStart) return [];

      const days = [];
      for (let i = 0; i < this.visibleDayCount; i++) {
        days.push(this.chartStart.add(i, 'day').clone());
      }

      return days;
    },

  groupedTasks() {
    const grouped = {};

      // Alle Einsätze nach LKW gruppieren
      this.tasks.forEach(task => {
        if (!grouped[task.rendszam]) {
          grouped[task.rendszam] = {
            rendszam: task.rendszam,
            akt_diszpecser: task.akt_diszpecser,
            tasks: [] // Liste der Balken für diesen LKW
          };
        }
        grouped[task.rendszam].tasks.push(task);
      });

      return Object.values(grouped); // Rückgabe als Array für `v-for`
    },
    
  fsz() {
        return this.getUserData ? this.getUserData.fsz : null;
  }, 

dailyRouteMatrix() {
  const matrix = [];

  this.groupedTasks.forEach(group => {
    const row = {
      rendszam: group.rendszam,
      akt_diszpecser: group.akt_diszpecser,
      routes: []
    };

    this.daysArray.forEach(day => {
      const routeTexts = group.tasks
        .filter(task =>
          dayjs(day).isBetween(task.planned_start, task.planned_end, 'day', '[]')
        )
        .map(task => task.route);

      row.routes.push(routeTexts.join('\n')); // mehrere Routen in einer Zelle (Zeilenumbruch)
    });

    matrix.push(row);
  });

  return matrix;
},




},


//************************************************************************************** */
mounted() {

  this.fetchDisponents();
    window.addEventListener("resize", this.updateGanttWidth);
    this.updateGanttWidth();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateGanttWidth);
  },



//##################################################################################
  methods: {

async deleteFuvar(az, oldal) {
try {
    
    let postData;
   
console.log('start deleteFuvar az=',az,' oldal=', oldal);

      postData = {
        az: az, // Identifizierende ID
        tipusField: oldal == 1 ? 'szoveg1' : 'szoveg2', // Bestimme neues Feld
        tipusValue: '...' // Setze neuen Wert
      };
    
    // Anfrage senden

    console.log('deleteFuvar',postData);
    const response = await axiosInstance.post('/drive/drive_chgtipus.php', postData);


console.log('response.data', response.data);

    if (response.status === 200 && response.data.success) {
   

      
      // Aktualisierte Daten erneut abrufen
     await this.fetchTasks();
      this.closeContextMenu(); // Optional: Contextmenü schließen

      ////console.log('Tipus erfolgreich aktualisiert in der Datenbank');
    } else {
      ////console.error('Fehler beim Aktualisieren des Tipus:', response.data.message);
      alert('Hiba történt az adatbázis frissítése közben (1).');
    }
  } catch (error) {
    ////console.error('Fehler bei der Anfrage zur Aktualisierung des Tipus:', error);
    alert('Hiba történt az adatbázis frissítése közben.');
  } finally {
    // Ladezustand zurücksetzen
 
  }
},

//********************************************************************** */    
 openDiszpecserList() {
    // Annahmen: 
    // - this.selectedFromDate und this.selectedToDateComputed enthalten die gewählten Daten (ISO-Format)
    // - this.selectedDisponent enthält den Namen/ID des Diszpécsers
    // - Firmen-ID ggf. aus Store holen
    const ceg_az = this.$store.getters.getUserData.ceg_az || '';
    const diszpecser = this.selectedDisponent === 'all' ? '' : this.selectedDisponent;
    const datumtol = this.selectedFromDate;
    const datumig = this.selectedToDateComputed;

    // Speichern im Store
    this.$store.commit('setDiszpecserPostData', {
      ceg_az,
      diszpecser,
      datumtol,
      datumig
    });

    // Routing zur neuen Seite
    this.$router.push({ name: 'weeklyDiszpList' });
  },


  openFeladatList() {


    this.$router.push({ name: 'FeladatList' });
  },



 barLabelOutsideStyle(task) {
    // Holt den Offset und Breite des Balkens, setzt den Text exakt daneben
    const bar = this.barStyle(task);
    return {
      position: 'absolute',
      left: bar.left ? `calc(${bar.left} + ${bar.width})` : '0px', // rechts vom Balken
      top: '50%',
      transform: 'translateY(-50%)',
      marginLeft: '4px',
      whiteSpace: 'nowrap'
    };
  },

  stripText(s) {
    return (s || '')
      .replace(/^H-/i, '')
      .replace(/\s*\(.*?\)/, '')
      .trim()
      .toLowerCase();
  },
getShortRelation(felrako, lerako) {
  // Nur H- entfernen, Klammerteil ohne unnötigen Backslash
  const strip = s => s ? s.replace(/^H-/, '').replace(/\s*\([^)]+\)/g, '').trim() : '';
  const abbr = s => strip(s).substring(0, 4);
  return `${abbr(felrako)} - ${abbr(lerako)}`;
},
getFullRelation(felrako, lerako) {
  const strip = s => s ? s.replace(/^H-/, '').replace(/\s*\([^)]+\)/g, '').trim() : '';
  return `${strip(felrako)} - ${strip(lerako)}`;
},

  showTextInBar(task) {
    const text = this.getShortRelation(task.felrako, task.lerako);
    const minWidthPerChar = 11;
    const minWidth = text.length * minWidthPerChar;
    const style = this.barStyle(task);
    const width = parseFloat((style.width || '0').replace('px', ''));
    return width >= minWidth;
  },


    
openFieldDialog(type, task = null) {

 console.log('openFieldDialog - type:', type, 'task:', task);

  // NEU: Task als Parameter (Fallback: this.selectedTask)
  const targetTask = task || this.selectedTask;
  if (!targetTask) {
    alert('Nincs kiválasztott fuvar (open)!');
    return;
  }

  this.selectedTask = targetTask; // redundante Sicherheit

  this.fieldType = type;
  switch(type) {
    case 'felrakasDatum':
      this.dialogTitle = 'Felrakás dátum módosítása';
      this.dialogInputType = 'date';
      this.fieldValue = targetTask.felrakas_datum 
        ? dayjs(targetTask.felrakas_datum).format('YYYY-MM-DD')
        : '';
      break;
    case 'lerakasDatum':
      this.dialogTitle = 'Lerakás dátum módosítása';
      this.dialogInputType = 'date';
      this.fieldValue = targetTask.lerakas_datum 
        ? dayjs(targetTask.lerakas_datum).format('YYYY-MM-DD')
        : '';
      break;
    case 'felrakoSuly':
      this.dialogTitle = 'Felrakó súly módosítása';
      this.dialogInputType = 'number';
      this.fieldValue = targetTask.fel_suly || '';
      break;
    case 'lerakoSuly':
      this.dialogTitle = 'Lerakó súly módosítása';
      this.dialogInputType = 'number';
      this.fieldValue = targetTask.le_suly || '';
      break;
    default:
      this.dialogTitle = 'Adat módosítása';
      this.dialogInputType = 'text';
      this.fieldValue = '';
  }
  this.showFieldDialog = true;
  this.closeContextMenu(); // Am Ende, damit Task noch da ist!
},

closeFieldDialog() {
  this.showFieldDialog = false;
  this.selectedTask = null;
  this.fieldType = '';
  this.dialogTitle = '';
  this.fieldValue = '';
},

//************************************************************** */
async saveFieldValue() {
  // Sicherstellen, dass Task gesetzt ist

console.log('vor Speichern-1:', this.selectedTask);


  const task = this.selectedTask;
  if (!task) {
    alert('Nincs kiválasztott fuvar!');
    return;
  }

  const changedData = {};
  // Felder nach Backend-Konvention
  if (this.fieldType === 'felrakasDatum') {
    changedData.felrakas_napja = this.fieldValue;
    task.felrakas_napja = this.fieldValue;
  }
  if (this.fieldType === 'lerakasDatum') {
    changedData.lerakas_napja = this.fieldValue;
    task.lerakas_napja = this.fieldValue;
  }
  if (this.fieldType === 'felrakoSuly') {
    changedData.fel_suly = this.fieldValue;
    task.fel_suly = this.fieldValue;
  }
  if (this.fieldType === 'lerakoSuly') {
    changedData.le_suly = this.fieldValue;
    task.le_suly = this.fieldValue;
  }

  // Prüfen, ob sich überhaupt etwas geändert hat
  if (Object.keys(changedData).length === 0) {
    return;
  }

  // Neues Datenpaket wie in editTruck.vue
  const postData = {
    az: task.az,
    fo_az: task.fo_az,         // falls vorhanden, sonst entfernen!
    mod_felh: this.fsz,
    data: changedData,
  };

  console.log('saveFieldValue postData-1:', postData);

  try {
    await axiosInstance.post('/napi_mellek/update_napimellek.php', postData);

         this.tasks = [...this.tasks]; // Trigger für Vue-Reaktivität
        this.closeFieldDialog();
          this.closeContextMenu();     // <<------ hier dazu!
        //this.showFieldDialog = false;
        //this.fieldType = '';
        //this.dialogTitle = '';
        //this.fieldValue = '';
  } catch (err) {
    alert("Sikertelen mentés! Nézze meg a konzolt.");
    console.error(err);
  }
},



//**************************************************** */
      filteredTasks(tasks) {
        return tasks.filter(t => dayjs(t.planned_start).isValid() && dayjs(t.planned_end).isValid());
      },


    selectDrive(drive) {
      this.selectedDrive = drive;
      console.log("✅ Kiválasztott viszonylat:", drive);

      const rendszam = this.selectedRendszam;
      const datum = this.selectedDatumString;

      this.showDriveSelector = false;

      if (!rendszam || !datum || !drive?.napifo_az) {
        alert("Hiányzó adat a mentéshez.");
        return;
      }

      const payload = {
        rendszam: rendszam,
        datum: datum,
        fsz: this.fsz,
        fo_az: drive.napifo_az
      };

      console.log('📤 Sende an init_from_order.php:', payload);

      axiosInstance.post('/napi_mellek/init_from_order.php', payload)
        .then((response) => {
          if (response.data?.success) {
            alert("✅ Viszonylat rögzítve!");
            this.fetchTasks(); // aktualisieren
          } else {
            alert("❌ Hiba a mentés során.");
            console.warn("Antwort:", response.data);
          }
        })
        .catch((error) => {
          console.error("❌ API-Hiba beim Speichern:", error);
          alert("Mentési hiba, nézze meg a konzolt.");
        });
    },

    closeDriveSelector() {
      this.showDriveSelector = false;
    },


      openTableContextMenu(event, row, dayIndex) {
          const day = this.daysArray?.[dayIndex];

          if (!day) {
            console.warn("⚠️ Kein gültiges Datum gefunden für Zelle:", dayIndex);
            return;
          }

          this.selectedTableRow = row;
          this.selectedDate = day;

        // 💾 Neue globale Hilfswerte:
        this.selectedRendszam = row.rendszam;
        this.selectedDatumString = day.format('YYYY-MM-DD');


          this.tableContextMenuVisible = true;
          this.tableContextMenuPosition = { x: event.clientX, y: event.clientY };

          console.log('📅 Rechtsklick-Tag:', day.format('YYYY-MM-DD'));
          console.log('🚛 Rendszám:', row.rendszam);

          document.addEventListener("click", this.closeTableContextMenu);
        },



    closeTableContextMenu() {
      this.tableContextMenuVisible = false;
      this.selectedTableRow = null;
      document.removeEventListener("click", this.closeTableContextMenu);
    },

//******************************************************************************** */    
  async handleTableMenu(action) {


  if (!this.selectedTableRow || !this.selectedDate) return;

  if (action === 'newDrive') {
    try {
      const payload = {
        cegaz: this.ceg_az,
        datum: this.selectedDate.format('YYYY-MM-DD')
      };

      console.log('newDrive PayLoad',payload);
      const response = await axiosInstance.post('/drive/list_driveFree.php', payload);

      if (response.data?.data?.length) {
            console.log("🚚 Freie Fahrten geladen:", response.data.data);
        console.log('response.data.data',response.data.data.length);
        this.freeDrives = response.data.data;
        this.showDriveSelector = true;
      } else {
        alert("❗ Nincs elérhető viszonylat erre a napra.");
      }
    } catch (error) {
      console.error("❌ Viszonylat lekérdezési hiba:", error);
      alert("Hiba történt a viszonylatok lekérésekor.");
    }
  }

  this.closeTableContextMenu();
}
,



 
 //*****   PDF ********************************************** */
  // ... (Ihre bestehenden Methoden) ...

async exportCurrentViewToPdf() {
  const exportId = this.showGantt ? 'gantt-export-content' : 'table-export-content';
  const exportElement = document.getElementById(exportId);

  if (!exportElement) {
    alert('Export-Elem hiányzik.');
    return;
  }

  const filename = this.showGantt ? 'Heti_idovonal.pdf' : 'Heti_tablazat.pdf';
  const orientation = this.showGantt ? 'landscape' : 'portrait';

  const opt = {
    margin: 0.6,
    filename: filename,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: "#ffffff"
    },
    jsPDF: {
      unit: 'in',
      format: 'a3',
      orientation: orientation
    }
  };

  try {
    const worker = html2pdf().set(opt).from(exportElement).toPdf();

    await worker.get('pdf').then(pdf => {
      const pageCount = pdf.internal.getNumberOfPages();
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      pdf.setFontSize(10);
      pdf.setTextColor(100);

      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        const footerText = `Oldal ${i} / ${pageCount}`;
        pdf.text(footerText, pageWidth - 1, pageHeight - 0.5, { align: 'right' });
      }
    });

    await worker.save();
    console.log('✅ PDF mit Fußzeile generiert');
  } catch (err) {
    console.error('❌ Fehler beim PDF-Export:', err);
    alert('Fehler beim PDF-Export – siehe Konsole.');
  }
},


  //******************************************************** */    
  async handleMenu(action, task) {
    // task ist das Task-Objekt aus dem Kontextmenü!
    if (!task) {
      alert("Nincs kiválasztott fuvar!");
      this.closeContextMenu();
      return;
    }
    console.log("kivalasztott task az=", task.az);

    this.kivalasztott_task = task.az;
    this.kivalasztottTaskObj = task; // komplette Referenz sichern

    if (action === 'setTime') {
      this.editStart = task.planned_start.format('YYYY-MM-DDTHH:mm');
      this.editEnd = task.planned_end.format('YYYY-MM-DDTHH:mm');
      this.timeEditorVisible = true;

    } else if (action === 'plan') {
      // 👉 HIER: Feladat + rakott útvonal anlegen
      try {
        console.log("🗓️ Betervezve für napi_mellek.az =", task.az);

        const resp = await axiosInstance.post(
          '/napi_mellek/create_feladat.php',
          {
            napiMellek_az: task.az
          }
        );

        console.log('create_feladat response:', resp.data);

        if (resp.data && resp.data.success) {
          const feladatId = resp.data.id;
          alert(`Feladat létrehozva (ID: ${feladatId}). Rakott útvonal is rögzítve.`);
          // Optional: wenn du später etwas im Gantt verändern willst:
          // await this.fetchTasks();
        } else {
          alert('Hiba a feladat létrehozásakor (success != true).');
        }
      } catch (e) {
        console.error('❌ API-hiba create_feladat.php hívás közben:', e);
        alert('Hiba történt a feladat létrehozása közben. Nézze meg a konzolt.');
      }
    }

    this.closeContextMenu();
  },


      cancelTimeEdit() {
        this.timeEditorVisible = false;
      },

      async saveTimeEdit() {
        console.log('💾 Speichern ausgelöst');

        try {
          const newStart = dayjs(this.editStart);
          const newEnd = dayjs(this.editEnd);

          console.log('🔍 Start:', newStart.format(), 'End:', newEnd.format());

          if (!newStart.isValid() || !newEnd.isValid() || newStart.isAfter(newEnd)) {
            alert("Hibás időpontok! Ellenőrizze az értékeket.");
            return;
          }


          console.log("🔎 selectedTask:", this.selectedTask);
          console.log("🔎 fsz:", this.fsz);



          if (!this.kivalasztott_task || !this.kivalasztottTaskObj || !this.fsz) {
            alert("Hiányzó adatok. (selectedTask vagy fsz)");
            return;
          }

          const payload = {
            az: this.kivalasztott_task,
            data: {
              planned_start: newStart.format('YYYY-MM-DD HH:mm:ss'),
              planned_end: newEnd.format('YYYY-MM-DD HH:mm:ss'),
              mod_felh: this.fsz
            }
          };

          console.log('📤 Daten werden gesendet:', payload);

          await axiosInstance.post('/napi_mellek/api_update_napiMellek.php', payload);

          // Werte übernehmen
          this.kivalasztottTaskObj.planned_start = dayjs(newStart);
          this.kivalasztottTaskObj.planned_end = dayjs(newEnd);
          this.tasks = [...this.tasks]; // Reaktivität

          this.kivalasztott_task = null;
          this.kivalasztottTaskObj = null;

          this.timeEditorVisible = false;
          console.log("✅ Mentés sikeres!");
        } catch (err) {
          console.error("❌ Fehler beim Speichern:", err);
          alert("Sikertelen mentés! Nézze meg a konzolt.");
        }
      },



calculateVisibleDuration(start, end) {
  let durationMinutes = 0;
  let current = dayjs(start);

  while (current.isBefore(end)) {
    const dayStart = current.hour(this.startHour).minute(0);
    const dayEnd = current.hour(this.endHour).minute(0);

    const taskStart = start.isAfter(dayStart) ? start : dayStart;
    const taskEnd = end.isBefore(dayEnd) ? end : dayEnd;

    if (taskEnd.isAfter(taskStart)) {
      durationMinutes += taskEnd.diff(taskStart, 'minute');
    }

    current = current.add(1, 'day').startOf('day');
  }

  return durationMinutes / 60; // in Stunden
},

    calculateVisibleOffset(start) {
      let offsetMinutes = 0;
      let current = this.chartStart.clone();

      while (current.isBefore(start, 'day')) {
        offsetMinutes += (this.endHour - this.startHour) * 60;
        current = current.add(1, 'day');
      }

      const dayStart = start.clone().hour(this.startHour).minute(0);
      if (start.isAfter(dayStart)) {
        offsetMinutes += start.diff(dayStart, 'minute');
      }

      return offsetMinutes;
    },



openContextMenu(event, task) {
  this.contextMenuVisible = true;
  this.contextMenuPosition = { x: event.clientX, y: event.clientY };
  this.contextMenuTask = task;
  this.contextMenuListener = (e) => {
    if (!e.target.closest('.context-menu')) {
      this.closeContextMenu();
    }
  };
  document.addEventListener("click", this.contextMenuListener);
},
closeContextMenu() {
  this.contextMenuVisible = false;
  this.contextMenuTask = null;
  if (this.contextMenuListener) {
    document.removeEventListener("click", this.contextMenuListener);
    this.contextMenuListener = null;
  }
},
//  handleMenu(action) {
//    console.log(`Akció: ${action} | Task ID: ${this.selectedTask.az}`);
//    this.closeContextMenu();
//  }, 



    dayCountIn() {
  if (this.visibleDayCount < 30) this.visibleDayCount += 1; // Zoom OUT → mehr Tage sichtbar
},
dayCountOut() {
  if (this.visibleDayCount > 1) this.visibleDayCount -= 1; // Zoom IN → weniger Tage sichtbar
},


resizeTask(task, edge, event) {
  const startX = event.clientX;
  const originalStart = dayjs(task.planned_start);
  const originalEnd = dayjs(task.planned_end);
  const pxPerHour = this.pxPerHour;
  const snapMinutes = 30;

  const onMouseMove = (e) => {
    const dx = e.clientX - startX;
    const movedMinutes = (dx / pxPerHour) * 60;
    const snappedMinutes = Math.round(movedMinutes / snapMinutes) * snapMinutes;

    if (edge === 'start') {
      let newStart = originalStart.add(snappedMinutes, 'minute');
      if (newStart.isBefore(originalEnd.subtract(15, 'minute'))) {
        task.planned_start = newStart;
      }
    } else if (edge === 'end') {
      let newEnd = originalEnd.add(snappedMinutes, 'minute');
      if (newEnd.isAfter(originalStart.add(15, 'minute'))) {
        task.planned_end = newEnd;
      }
    }
  };

  const onMouseUp = async () => {
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);

    try {
      const updateData = {
        planned_start: task.planned_start.format('YYYY-MM-DD HH:mm:ss'),
        planned_end: task.planned_end.format('YYYY-MM-DD HH:mm:ss'),
        mod_felh: this.fsz
      };

      await axiosInstance.post('/napi_mellek/api_update_napiMellek.php', {
        az: task.az,
        data: updateData
      });
    } catch (err) {
      console.error('❌ Fehler beim Server-Update:', err);
    }
  };

  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('mouseup', onMouseUp);
}
,




async dragTask(task, event) {
  const startX = event.clientX;
  const originalStart = dayjs(task.planned_start);
  const originalEnd = dayjs(task.planned_end);

  const pxPerHour = this.pxPerHour;
  const snapMinutes = 30; // oder 60 für Stundenraster

  const onMouseMove = (e) => {
    const dx = e.clientX - startX;
    const movedMinutes = (dx / pxPerHour) * 60;

// Auf nächstes Snapping-Level runden (z. B. 30 Minuten)
    const snappedMinutes = Math.round(movedMinutes / snapMinutes) * snapMinutes;

    task.planned_start = originalStart.add(snappedMinutes, 'minute');
    task.planned_end = originalEnd.add(snappedMinutes, 'minute');
  };

  const onMouseUp = async () => {
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', onMouseUp);

    try {
      const updateData = {
        planned_start: task.planned_start.format('YYYY-MM-DD HH:mm:ss'),
        planned_end: task.planned_end.format('YYYY-MM-DD HH:mm:ss'),
        mod_felh: this.fsz
      };

      await axiosInstance.post('/napi_mellek/api_update_napiMellek.php', {
        az: task.az,
        data: updateData
      });

      console.log(`✅ Task ${task.az} updated.`);
    } catch (err) {
      console.error('❌ Fehler beim Server-Update:', err);
    }
  };

  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('mouseup', onMouseUp);
}
,


updateGanttWidth() {
  if (this.$refs.ganttContainer) {
    this.ganttWidth = this.$refs.ganttContainer.clientWidth; // ✅ nur das hier setzen!
  }
},


//********************************************************************************************* */

async fetchDisponents() {
      try {
        const payload = {
          ceg_az: this.ceg_az,
          start: this.selectedFromDate,
          end: this.selectedToDateComputed
        };

        const response = await axiosInstance.post('/napi_mellek/list_weekDiszpecser.php', payload);

        if (response.data && response.data.data) {
                        this.disponents = response.data.data.map(d => ({
                          name: d.diszpecser
                        }));

                    // 🧠 DEBUG: Benutzer ist diszpécser?
                  console.log('👤 UserType:', this.getUserType);
                  console.log('🧑‍💼 Angemeldeter Benutzername (nev):', this.getUserData.nev);
                  console.log('📋 Disponentenliste:', this.disponents.map(d => d.name));

                  // Prüfung ob der User ein Diszpécser ist
                  if (this.getUserType === 'diszpécser') {
                        const userName = this.getUserData.nev;

                        // Versuche exakte Übereinstimmung zu finden
                        const exists = this.disponents.some(d => d.name === userName);

                        console.log('🔍 Existiert Benutzer in Diszpécser-Liste:', exists);

                        if (exists) {
                          this.selectedDisponent = userName;
                          console.log('✅ Diszpécser gesetzt:', this.selectedDisponent);
                        } else {
                          console.warn('⚠️ Benutzername nicht in Diszpécser-Liste gefunden:', userName);
                        }
                  }
        } else {
          this.disponents = [];
        }

        console.log("👤 Geladene Diszpécserek:", this.disponents);
      } catch (error) {
        console.error('❌ Fehler beim Laden der Diszpécser:', error);
        this.disponents = [];
      }
    },



//************************************************************************* */

    async fetchTasks() {
      try {
        console.log("📅 Vorher: chartStart =", this.chartStart ? this.chartStart.format('YYYY-MM-DD HH:mm:ss') : "❌ nicht gesetzt");
        console.log("📅 Vorher: chartEnd =", this.chartEnd ? this.chartEnd.format('YYYY-MM-DD HH:mm:ss') : "❌ nicht gesetzt");

        const payload = {
          ceg_az: this.ceg_az,
          start: dayjs(this.selectedFromDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          end: this.chartEndComputed.format('YYYY-MM-DD HH:mm:ss'),
          diszpecser: this.selectedDisponent !== 'all' ? this.selectedDisponent : '%'
        };

    console.log('payload',payload);

        const response = await axiosInstance.post('/napi_mellek/list_weekTime.php', payload, {
          headers: { 'Content-Type': 'application/json' }
        });

        if (response.data && response.data.data) {
          this.tasks = response.data.data.map(task => ({
            ...task,
            planned_start: dayjs(task.planned_start),
            planned_end: dayjs(task.planned_end)
          }));

          console.log("📌 Geladene Tasks:", this.tasks);

          // ✅ `chartStart` direkt auf `selectedFromDate` setzen
          this.chartStart = dayjs(this.selectedFromDate).startOf('day');
          this.chartEnd = dayjs(this.selectedToDateComputed).endOf('day');

          console.log("📅 Nachher: chartStart =", this.chartStart.format('YYYY-MM-DD HH:mm:ss'));
          console.log("📅 Nachher: chartEnd =", this.chartEnd.format('YYYY-MM-DD HH:mm:ss'));


          console.log("📌 Geladene Tasks:");
    this.tasks.forEach(task => {
      console.log(`LKW: ${task.rendszam}, Start: ${task.planned_start.format('YYYY-MM-DD HH:mm:ss')}, End: ${task.planned_end.format('YYYY-MM-DD HH:mm:ss')}`);
    });


        } else {
          this.tasks = [];
        }
      } catch (error) {
        console.error('Fehler beim Laden der Daten:', error);
        this.tasks = [];
      }
    },




    setWeekRange(type) {
      let baseDate;

      this.zoomLevel=1;
      this.visibleDayCount = 7;


      // Fallback, falls das Datum leer ist
      const currentSelected = this.selectedFromDate
        ? dayjs(this.selectedFromDate)
        : dayjs().startOf('isoWeek');

      if (type === 'prev') {
        baseDate = currentSelected.subtract(1, 'week');
      } else if (type === 'current') {
        baseDate = dayjs(); // heute
      } else if (type === 'next') {
        baseDate = currentSelected.add(1, 'week');
      }

      this.selectedFromDate = baseDate.startOf('isoWeek').format('YYYY-MM-DD');
      this.selectedToDate = baseDate.endOf('isoWeek').format('YYYY-MM-DD');

      this.fetchDisponents(); // hinzufügen in setWeekRange

      this.fetchTasks();
    },

//*********************************************************************************** */
    barStyle(task) {
      if (!task || !task.planned_start || !task.planned_end) return {};

      const pxPerHour = this.pxPerHour;

      const offsetMinutes = this.calculateVisibleOffset(task.planned_start);
      const durationHours = this.calculateVisibleDuration(task.planned_start, task.planned_end);

      return {
        left: `${(offsetMinutes / 60) * pxPerHour}px`,
        width: `${Math.max(15, durationHours * pxPerHour)}px`,
        backgroundColor: '#007bff'
      };
    }








  }
};
</script>

<style scoped>
.gantt-container {
  display: grid;
  grid-template-columns: 300px 1fr;
  width: 100vw;
  overflow-x: auto;
}

.gantt-bar-wrapper {
  position: relative;
  height: 40px; /* Muss exakt wie .gantt-row sein! */
  /* KEIN display: flex, wenn du absolute Position nutzt! */
}


/* 📌 Fix 1: Einheitliche Höhe für die Kopfzeilen */
.tasks-table thead tr, .gantt-header {
  height: 40px; /* Gleiche Höhe für Tabellenkopf und Timeline-Kopf */
  line-height: 15px; /* Vertikale Zentrierung */
  padding: 0; /* Entferne unnötiges Padding */
  border-bottom: 1px solid #ccc;
  background: #f8f9fa;
  font-weight: bold;
  text-align: center;
  font-size: 0.8rem;
}

/* 📌 Fix 2: Gleiche Höhe für alle Zeilen in der Tabelle und Gantt-Ansicht */
.tasks-table tbody tr, .gantt-row {
  height: 40px; /* Einheitliche Höhe */
  font-size: 0.8rem;
}

/* 📌 Fix 3: Tabelle links */
.gantt-left {
  overflow: auto; /* Falls zu viele Zeilen */
  border-right: 1px solid #ccc;
}

.tasks-table {
  width: 100%;
  border-collapse: collapse;
}

.tasks-table th, .tasks-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.gantt-header {
  display: flex;
  flex-direction: column; /* ❗ ermöglicht mehrere Zeilen */
  height: auto;
  border-bottom: 1px solid #ccc;
  background: #f8f9fa;
}

.gantt-header-scale {
  display: flex;
  width: 100%;
  align-items: center;
}

.gantt-header-day {
  text-align: center;
  border-right: 1px solid #ccc;
  font-size: 0.8rem;
  line-height: 40px;
  min-width: 100px;
}

.gantt-right {
  overflow-x: auto;
  flex-grow: 1;
}

.gantt-body {
  position: relative;
  width: 100%; /* Muss mit `timelineWidth` übereinstimmen */
  overflow-x: auto; /* Falls nötig, damit Balken nicht abgeschnitten werden */
}

.gantt-day-line {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px; /* Dünne Linie */
  background-color: rgba(0, 0, 0, 0.1); /* Dezente Farbe */
  z-index: 0; /* 👈 unterste Ebene */
}

.gantt-row {
  position: relative;
  border-bottom: 1px solid #ccc;
  width: 100%; /* Muss auf volle Breite gesetzt werden */
}

.gantt-bar {
  position: absolute;
  top: 50%;
  transform: translateY(-50%); /* Perfekte Zentrierung */
  height: 18px; /* ❗ Kleiner & filigraner statt 30px */
  border-radius: 6px; /* ❗ Runde Ecken für ein weiches Design */
  background-color: #007bff; /* Standardblau */
  min-width: 10px; /* ❗ Kleinere Mindestbreite für kurze Balken */
  opacity: 0.85; /* ❗ Leicht transparent für eine modernere Optik */
  transition: all 0.3s ease-in-out; /* ❗ Sanfte Animation bei Änderungen */
   z-index: 1;
}

/* ❗ Farbänderung beim Hover für besseren Fokus */
.gantt-bar:hover {
  opacity: 1;
  background-color: #0056b3;
  cursor: pointer;
}

.resize-handle {
  position: absolute;
  top: 0;
  width: 8px;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  cursor: ew-resize;
  z-index: 10;
}

.resize-handle.left {
  left: 0;
  border-left: 2px solid #333;
}

.resize-handle.right {
  right: 0;
  border-right: 2px solid #333;
}

.gantt-hour-line {
  position: absolute;
  top: 0;
  bottom: 0;
  
  z-index: 100;
}

.filter-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  gap: 10px;
}

.filter-left {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.zoom-controls {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 0.85rem;
}
.zoom-controls button {
  font-size: 1rem;
  padding: 0 6px;
}

.gantt-time-scale {
  display: flex;
  height: 24px;
  border-bottom: 1px solid #ccc;
  font-size: 0.75rem;
  background: #f3f3f3;
  align-items: center;
}

.gantt-time-label-group {
  position: relative;
  display: inline-block;
  height: 100%;
  width: 100%;
  border-right: 1px solid #ddd;
}

.gantt-time-label {
  position: absolute;
  top: 2px;
  transform: translateX(-50%);
  white-space: nowrap;
  color: #444;
}

.time-header-placeholder-row td {
  padding: 0;
  margin: 0;
}

.time-header-placeholder {
  height: 24px; /* exakt wie .gantt-time-scale */
  background: #f3f3f3;
  border-bottom: 1px solid #ccc;
}


.context-menu {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  list-style: none;
  padding: 0;
  margin: 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  width: 240px;
}

.context-menu li {
  padding: 10px;
  cursor: pointer;
}

.context-menu li:hover {
  background-color: #f5f5f5;
}

.time-editor {
  position: absolute;
  background: #fff;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 260px;
}

.editor-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.editor-actions button {
  padding: 4px 10px;
}

.view-toggle {
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.view-toggle button {
  padding: 6px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.view-toggle button:hover {
  background-color: #0056b3;
}

.routes-table-wrapper {
  margin-top: 20px;
  overflow-x: auto;
}

.routes-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
  table-layout: fixed; /* sorgt für gleichmäßige Spaltenbreiten */
  border: 1px solid #999;
}

.routes-table th,
.routes-table td {
  border: 1px solid #999;
  padding: 6px;
  text-align: center;
  white-space: normal;     /* ❗️ ermöglicht Zeilenumbruch */
  word-wrap: break-word;   /* ❗️ bricht lange Wörter */
  overflow-wrap: break-word;
  overflow: hidden;
}

.routes-table th {
  background-color: #e9ecef;
  font-weight: bold;
}

.cell-multiline {
  white-space: pre-wrap;
  font-family: inherit;
  margin: 0;
  text-align: left;
  padding: 4px;
}

.export-button-container {
  text-align: right;
  padding: 8px;
  margin-top: 10px;
}

.export-button-container button {
  padding: 8px 15px;
  background-color: #28a745; /* Grün für Export */
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.export-button-container button:hover {
  background-color: #218838;
}


@media print {
  body * {
    visibility: hidden;
  }
  #gantt-export-content, #table-export-content {
    visibility: visible;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 10001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-height: 80vh;
  width: 500px;
  overflow-y: auto;
}

.modal h3 {
  margin-bottom: 10px;
}

.drive-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.drive-list li {
  padding: 10px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

.drive-list li:hover {
  background-color: #f0f0f0;
}

.modal-actions {
  margin-top: 15px;
  text-align: right;
}

.modal {
  display: block !important;
  visibility: visible !important;
  z-index: 10010;
  background: white;
}

.bar-label {
  color: #fff;
  font-size: 12px;
  /* kein font-weight: bold; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  width: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}


.bar-label-outside {
  color: #007bff;
  font-size: 12px;
  white-space: nowrap;
  user-select: none;
  pointer-events: none;
  position: absolute;
  left: 100%;              /* Direkt rechts neben dem Balken */
  top: 50%;
  transform: translateY(-50%);
  margin-left: 8px;
}

.bar-label, .bar-label-outside {
  pointer-events: none;
}

.gantt-bar::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 24px;   /* Mindest-Klickfläche, nach Wunsch größer */
  height: 28px;  /* oder height: 100%; wenn du willst */
  background: transparent;
  z-index: 2;
  pointer-events: auto;
}

</style>
